module.exports = __webpack_public_path__ + "static/media/freelancer-image-solutions-2.2dff1eb7.webp";